import { createClearPropMutation, createSetPropMutation } from '@/store/utils';
import * as types from '@/store/configuration/mutationTypes';

export default {
  [types.SET_TOP_LEVEL_DOMAINS]: createSetPropMutation('topLevelDomains', []),
  [types.CLEAR_TOP_LEVEL_DOMAINS]: createClearPropMutation('topLevelDomains', []),
  [types.SET_TOP_LEVEL_DOMAINS_ASSETS]: createSetPropMutation('topLevelDomainsAssets', []),
  [types.CLEAR_TOP_LEVEL_DOMAINS_ASSETS]: createClearPropMutation('topLevelDomainsAssets', []),
  [types.SET_TOP_LEVEL_DOMAINS_OPTIONS]: createSetPropMutation('topLevelDomainsOptions', []),
  [types.CLEAR_TOP_LEVEL_DOMAINS_OPTIONS]: createClearPropMutation('topLevelDomainsOptions', []),
  [types.SET_SUCCESS_OPERATION_MESSAGE]: createSetPropMutation('successOperationMessage', ''),
  [types.CLEAR_SUCCESS_OPERATION_MESSAGE]: createClearPropMutation('successOperationMessage', ''),
  [types.SET_DOWNLOAD_REPORT_DISABLE]: createSetPropMutation('downloadReportDisabled', false),
  [types.CLEAR_TOP_LEVEL_DOMAIN_LIST_OPTIONS]: createClearPropMutation('topLevelDomainListOptions'),
  [types.SET_TOP_LEVEL_DOMAIN_LIST_OPTIONS](state, options = {}) {
    state.topLevelDomainListOptions = {
      ...(state.topLevelDomainListOptions || {}),
      ...options,
    };
  },
  [types.SET_INFRASTRUCTURE]: createSetPropMutation('infrastructureItems', []),
  [types.CLEAR_INFRASTRUCTURE]: createClearPropMutation('infrastructureItems', []),
  [types.SET_PORT_OPTIONS]: createSetPropMutation('portOptions', []),
  [types.CLEAR_PORT_OPTIONS]: createClearPropMutation('portOptions', []),
  [types.SET_WAF_OPTIONS]: createSetPropMutation('wafOptions', []),
  [types.CLEAR_WAF_OPTIONS]: createClearPropMutation('wafOptions', []),
  [types.SET_SERVICES_OPTIONS]: createSetPropMutation('servicesOptions', []),
  [types.CLEAR_SERVICES_OPTIONS]: createClearPropMutation('servicesOptions', []),
  [types.SET_LOCATION_OPTIONS]: createSetPropMutation('locationOptions', {}),
  [types.CLEAR_LOCATION_OPTIONS]: createClearPropMutation('locationOptions', {}),
  [types.SET_COORDINATES_OPTIONS]: createSetPropMutation('coordinatesOptions', {}),
  [types.CLEAR_COORDINATES_OPTIONS]: createClearPropMutation('coordinatesOptions', {}),
  [types.SET_SUBDOMAIN_TAGS_SUGGESTIONS]: createSetPropMutation('infrastructureTagsSuggestions', []),
  [types.CLEAR_SUBDOMAIN_TAGS_SUGGESTIONS]: createClearPropMutation('infrastructureTagsSuggestions', []),
  [types.SET_DOMAIN_TAGS_SUGGESTIONS]: createSetPropMutation('topLevelDomainTagsSuggestions', []),
  [types.CLEAR_DOMAIN_TAGS_SUGGESTIONS]: createClearPropMutation('topLevelDomainTagsSuggestions', []),
  [types.CLEAR_INFRASTRUCTURE_LIST_OPTIONS]: createClearPropMutation('infrastructureListOptions'),
  [types.SET_INFRASTRUCTURE_LIST_OPTIONS](state, options = {}) {
    state.infrastructureListOptions = {
      ...(state.infrastructureListOptions || {}),
      ...options,
    };
  },
  [types.SET_LEAKS]: createSetPropMutation('leaksItems', []),
  [types.CLEAR_LEAKS]: createClearPropMutation('leaksItems', []),
  [types.CLEAR_LEAKS_LIST_OPTIONS]: createClearPropMutation('leaksListOptions'),
  [types.SET_LEAKS_LIST_OPTIONS](state, options = {}) {
    state.leaksListOptions = {
      ...(state.leaksListOptions || {}),
      ...options,
    };
  },
  [types.SET_TLDS_WITH_NO_LEAKS_SCAN]: createSetPropMutation('tldsWithNoLeaksScan', []),
  [types.CLEAR_TLDS_WITH_NO_LEAKS_SCAN]: createClearPropMutation('tldsWithNoLeaksScan', []),
  [types.SET_TLDS_WITH_LEAKS_SCAN]: createSetPropMutation('tldsWithLeaksScan', []),
  [types.CLEAR_TLDS_WITH_LEAKS_SCAN]: createClearPropMutation('tldsWithLeaksScan', []),
  [types.SET_LEAKS_SOURCE_OPTIONS]: createSetPropMutation('leaksSourceOptions', []),
  [types.CLEAR_LEAKS_SOURCE_OPTIONS]: createClearPropMutation('leaksSourceOptions', []),
  [types.SET_LEAKS_TYPE_OPTIONS]: createSetPropMutation('leaksTypeOptions', []),
  [types.CLEAR_LEAKS_TYPE_OPTIONS]: createClearPropMutation('leaksTypeOptions', []),
  [types.SET_EMPLOYEES]: createSetPropMutation('employeesItems', []),
  [types.CLEAR_EMPLOYEES]: createClearPropMutation('employeesItems', []),
  [types.CLEAR_EMPLOYEES_LIST_OPTIONS]: createClearPropMutation('employeesListOptions'),
  [types.SET_EMPLOYEES_LIST_OPTIONS](state, options = {}) {
    state.employeesListOptions = {
      ...(state.employeesListOptions || {}),
      ...options,
    };
  },
  [types.SET_TLDS_WITH_NO_EMPLOYEES_SCAN]: createSetPropMutation('tldsWithNoEmployeesScan', []),
  [types.CLEAR_TLDS_WITH_NO_EMPLOYEES_SCAN]: createClearPropMutation('tldsWithNoEmployeesScan', []),
  [types.SET_TLDS_WITH_EMPLOYEES_SCAN]: createSetPropMutation('tldsWithEmployeesScan', []),
  [types.CLEAR_TLDS_WITH_EMPLOYEES_SCAN]: createClearPropMutation('tldsWithEmployeesScan', []),
  [types.SET_TECHNOLOGIES]: createSetPropMutation('technologiesItems', []),
  [types.CLEAR_TECHNOLOGIES]: createClearPropMutation('technologiesItems', []),
  [types.CLEAR_TECHNOLOGIES_LIST_OPTIONS]: createClearPropMutation('technologiesListOptions'),
  [types.SET_TECHNOLOGIES_LIST_OPTIONS](state, options = {}) {
    state.technologiesListOptions = {
      ...(state.technologiesListOptions || {}),
      ...options,
    };
  },
  [types.SET_PASSWORD_SPRAY_STATS_UPDATED]: createSetPropMutation('passwordSprayStatsUpdated', false),
  [types.CLEAR_PASSWORD_SPRAY_STATS_UPDATED]: createClearPropMutation('passwordSprayStatsUpdated', false),
  [types.SET_CLOUD_INSTANCES]: createSetPropMutation('cloudInstancesItems', []),
  [types.CLEAR_CLOUD_INSTANCES]: createClearPropMutation('cloudInstancesItems', []),
  [types.CLEAR_CLOUD_INSTANCES_LIST_OPTIONS]: createClearPropMutation('cloudInstancesListOptions'),
  [types.SET_CLOUD_INSTANCES_LIST_OPTIONS](state, options = {}) {
    state.cloudInstancesListOptions = {
      ...(state.cloudInstancesListOptions || {}),
      ...options,
    };
  },
  [types.SET_CLOUD_INSTANCES_FULL_ITEMS]: createSetPropMutation('cloudInstancesFullItems', []),
  [types.CLEAR_CLOUD_INSTANCES_FULL_ITEMS]: createClearPropMutation('cloudInstancesFullItems', []),
  [types.SET_CLOUD_BUCKETS]: createSetPropMutation('cloudBucketsItems', []),
  [types.CLEAR_CLOUD_BUCKETS]: createClearPropMutation('cloudBucketsItems', []),
  [types.CLEAR_CLOUD_BUCKETS_LIST_OPTIONS]: createClearPropMutation('cloudBucketsListOptions'),
  [types.SET_CLOUD_BUCKETS_LIST_OPTIONS](state, options = {}) {
    state.cloudBucketsListOptions = {
      ...(state.cloudBucketsListOptions || {}),
      ...options,
    };
  },
  [types.SET_CLOUD_BUCKETS_FULL_ITEMS]: createSetPropMutation('cloudBucketsFullItems', []),
  [types.CLEAR_CLOUD_BUCKETS_FULL_ITEMS]: createClearPropMutation('cloudBucketsFullItems', []),
  [types.SET_LOADING_PASSWORD_SPRAY]: createSetPropMutation('loadingPasswordSpray', false),
  [types.SET_PASSWORD_SPRAY_NOT_VALIDATE_DOMAINS]: createSetPropMutation('notValidatedDomains', []),
  [types.CLEAR_PASSWORD_SPRAY_NOT_VALIDATE_DOMAINS]: createClearPropMutation('notValidatedDomains', []),
  [types.SET_PASSWORD_SPRAY_DOMAINS_WITHOUT_LICENSE]: createSetPropMutation('domainsWithoutLicense', []),
  [types.CLEAR_PASSWORD_SPRAY_DOMAINS_WITHOUT_LICENSE]: createClearPropMutation('domainsWithoutLicense', []),
  [types.SET_TOP_LEVEL_DOMAINS_LOADING]: createSetPropMutation('topLevelDomainsLoading', false),
  [types.SET_INFRASTRUCTURE_LOADING]: createSetPropMutation('infrastructureLoading', false),
  [types.SET_EMPLOYEES_LOADING]: createSetPropMutation('employeesLoading', false),
  [types.SET_TECHNOLOGIES_LOADING]: createSetPropMutation('technologiesLoading', false),
  [types.SET_LEAKS_LOADING]: createSetPropMutation('leaksLoading', false),
  [types.SET_CLOUD_INSTANCES_LOADING]: createSetPropMutation('cloudInstancesLoading', false),
  [types.SET_CLOUD_BUCKETS_LOADING]: createSetPropMutation('cloudBucketsLoading', false),
  [types.SET_CLOUD_SERVICES_LOADING]: createSetPropMutation('cloudServicesLoading', false),
  [types.SET_CLOUD_ACCOUNTS_LOADING]: createSetPropMutation('cloudAccountsLoading', false),
  [types.SET_INFRASTRUCTURE_REF_ID]: createSetPropMutation('infrastructureRefId', ''),
  [types.CLEAR_INFRASTRUCTURE_REF_ID]: createClearPropMutation('infrastructureRefId', ''),
  [types.SET_INFRASTRUCTURE_PROGRESS]: createSetPropMutation('infrastructureProgress', 0),
  [types.CLEAR_INFRASTRUCTURE_PROGRESS]: createClearPropMutation('infrastructureProgress', 0),
  [types.SET_EMPLOYEES_REF_ID]: createSetPropMutation('employeesRefId', ''),
  [types.CLEAR_EMPLOYEES_REF_ID]: createClearPropMutation('employeesRefId', ''),
  [types.SET_EMPLOYEES_PROGRESS]: createSetPropMutation('employeesProgress', 0),
  [types.CLEAR_EMPLOYEES_PROGRESS]: createClearPropMutation('employeesProgress', 0),
  [types.SET_TECHNOLOGIES_REF_ID]: createSetPropMutation('technologiesRefId', ''),
  [types.CLEAR_TECHNOLOGIES_REF_ID]: createClearPropMutation('technologiesRefId', ''),
  [types.SET_TECHNOLOGIES_PROGRESS]: createSetPropMutation('technologiesProgress', 0),
  [types.CLEAR_TECHNOLOGIES_PROGRESS]: createClearPropMutation('technologiesProgress', 0),
  [types.SET_CLOUD_INSTANCES_REF_ID]: createSetPropMutation('cloudInstancesRefId', ''),
  [types.CLEAR_CLOUD_INSTANCES_REF_ID]: createClearPropMutation('cloudInstancesRefId', ''),
  [types.SET_CLOUD_INSTANCES_PROGRESS]: createSetPropMutation('cloudInstancesProgress', 0),
  [types.CLEAR_CLOUD_INSTANCES_PROGRESS]: createClearPropMutation('cloudInstancesProgress', 0),
  [types.SET_CLOUD_BUCKETS_REF_ID]: createSetPropMutation('cloudBucketsRefId', ''),
  [types.CLEAR_CLOUD_BUCKETS_REF_ID]: createClearPropMutation('cloudBucketsRefId', ''),
  [types.SET_CLOUD_BUCKETS_PROGRESS]: createSetPropMutation('cloudBucketsProgress', 0),
  [types.CLEAR_CLOUD_BUCKETS_PROGRESS]: createClearPropMutation('cloudBucketsProgress', 0),
  [types.SET_CLOUD_SERVICES_REF_ID]: createSetPropMutation('cloudServicesRefId', ''),
  [types.CLEAR_CLOUD_SERVICES_REF_ID]: createClearPropMutation('cloudServicesRefId', ''),
  [types.SET_CLOUD_SERVICES_PROGRESS]: createSetPropMutation('cloudServicesProgress', 0),
  [types.CLEAR_CLOUD_SERVICES_PROGRESS]: createClearPropMutation('cloudServicesProgress', 0),
  [types.SET_TOP_LEVEL_DOMAINS_REF_ID]: createSetPropMutation('topLevelDomainsRefId', ''),
  [types.CLEAR_TOP_LEVEL_DOMAINS_REF_ID]: createClearPropMutation('topLevelDomainsRefId', ''),
  [types.SET_TOP_LEVEL_DOMAINS_PROGRESS]: createSetPropMutation('topLevelDomainsProgress', 0),
  [types.CLEAR_TOP_LEVEL_DOMAINS_PROGRESS]: createClearPropMutation('topLevelDomainsProgress', 0),
  [types.SET_INFRASTRUCTURE_RUNNING_INTERVAL]: createSetPropMutation('infrastructureRunningInterval', false),
  [types.SET_EMPLOYEES_RUNNING_INTERVAL]: createSetPropMutation('employeesRunningInterval', false),
  [types.SET_TLD_RUNNING_INTERVAL]: createSetPropMutation('tldRunningInterval', false),
  [types.SET_TECHNOLOGIES_RUNNING_INTERVAL]: createSetPropMutation('technologiesRunningInterval', false),
  [types.SET_CLOUD_BUCKETS_RUNNING_INTERVAL]: createSetPropMutation('cloudBucketsRunningInterval', false),
  [types.SET_CLOUD_INSTANCES_RUNNING_INTERVAL]: createSetPropMutation('cloudInstancesRunningInterval', false),
  [types.SET_CLOUD_SERVICES_RUNNING_INTERVAL]: createSetPropMutation('cloudServicesRunningInterval', false),
  [types.SET_LEAKS_REF_ID]: createSetPropMutation('leaksRefId', ''),
  [types.CLEAR_LEAKS_REF_ID]: createClearPropMutation('leaksRefId', ''),
  [types.SET_LEAKS_PROGRESS]: createSetPropMutation('leaksProgress', 0),
  [types.CLEAR_LEAKS_PROGRESS]: createClearPropMutation('leaksProgress', 0),
  [types.SET_LEAKS_RUNNING_INTERVAL]: createSetPropMutation('leaksRunningInterval', false),
  [types.SET_RETRY_COUNTER]: createSetPropMutation('retryCounter', {}),
  [types.SET_INFOSTEALERS_ITEMS]: createSetPropMutation('infostealersItems', []),
  [types.CLEAR_INFOSTEALERS_ITEMS]: createClearPropMutation('infostealersItems', []),
  [types.SET_INFOSTEALERS_LOADING]: createSetPropMutation('infostealersLoading', false),
  [types.SET_INFOSTEALERS_FILTERS]: createSetPropMutation('infostealersFilters', {}),
  [types.SET_INFOSTEALERS_LIST_OPTIONS](state, options = {}) {
    state.infostealersListOptions = {
      ...state.infostealersListOptions,
      ...options,
    };
  },
  [types.SET_INFOSTEALERS_PAGINATION_STATE]: createSetPropMutation('infostealersListOptions', {}),
  [types.SET_INFOSTEALERS_REF_ID]: createSetPropMutation('infostealersRefId', ''),
  [types.CLEAR_INFOSTEALERS_REF_ID]: createClearPropMutation('infostealersRefId', ''),
  [types.SET_INFOSTEALERS_PROGRESS]: createSetPropMutation('infostealersProgress', 0),
  [types.CLEAR_INFOSTEALERS_PROGRESS]: createClearPropMutation('infostealersProgress', 0),
  [types.SET_INFOSTEALERS_PROGRESS_DATA]: createSetPropMutation('infostealersProgressData', { running_jobs: [], total_running: 0 }),
  [types.SET_INFOSTEALERS_RUNNING_INTERVAL]: createSetPropMutation('infostealersRunningInterval', false),
  [types.SET_INFOSTEALERS_POLLING_INTERVAL]: createSetPropMutation('infostealersPollingInterval', null),
  [types.SET_LAST_INFOSTEALERS_PROGRESS_CALL]: createSetPropMutation('lastInfostealersProgressCall', null),
};
